import styled from "styled-components";
import { SignOutUser } from "../../../Firebase";
import PWABanner from "../PWA-Banner/PWA-Banner";
import { useContext } from "react";
import { CurrentUserContext } from "../../../Contexts/CurrentUserContext";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 300px;
  text-align: center;

  button {
    background-color: white;
    color: var(--accent-color-dark);
    border: 1px solid var(--accent-color-dark);
    border-radius: 5px;
    padding: 10px 40px;
    font-size: 20px;
    font-weight: 600;
  }
  button:hover {
    background-color: var(--accent-color-dark);
    color: white;
  }

  @media (max-width: 768px) {
    button:hover {
      background-color: initial;
      color: initial;
    }
  }
`;

export default function NoUserPage() {
  const currentUser = useContext(CurrentUserContext);
  return (
    <Wrapper>
      <p>
        {currentUser?.currentFirebaseUser?.email}
        <br/>
        Your access to this app has been granted but your role has not been
        defined.
      </p>
      <button onClick={SignOutUser}>Log Out</button>
      <PWABanner loginPage={true} />
    </Wrapper>
  );
}
